module.exports = __webpack_public_path__ + "static/media/hospitalGrid-04.e90dfaaf.jpg";